/**
 * Status "tones" as complete Tailwind class strings.
 *
 * Tailwind only generates classes it can find literally in source, so dynamic
 * colour choices (score → green/amber/red, status → tone) must pick from a map
 * like this one instead of building `text-${tone}` strings at runtime.
 */
export const TONES = Object.freeze({
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
  INFO: "info",
  PRIMARY: "primary",
  ACCENT: "accent",
});

// text: readable foreground on container bg
// soft: subtle chip/badge (bg + border + text), works in light and dark
// solid: strong fill (dot, bar, indicator)
export const TONE_CLASSES = Object.freeze({
  success: {
    text: "text-success-text",
    soft: "bg-success-bg border-success-border text-success-text",
    solid: "bg-success",
  },
  warning: {
    text: "text-warning-text",
    soft: "bg-warning-bg border-warning-border text-warning-text",
    solid: "bg-warning",
  },
  error: {
    text: "text-error-text",
    soft: "bg-error-bg border-error-border text-error-text",
    solid: "bg-error",
  },
  info: {
    text: "text-info-text",
    soft: "bg-info-bg border-info-border text-info-text",
    solid: "bg-info",
  },
  primary: {
    text: "text-primary-text",
    soft: "bg-primary-bg border-primary-border text-primary-text",
    solid: "bg-primary",
  },
  accent: {
    text: "text-accent-text",
    soft: "bg-accent-bg border-accent-border text-accent-text",
    solid: "bg-accent",
  },
});

export const toneClass = (tone, variant = "text") =>
  (TONE_CLASSES[tone] || TONE_CLASSES.info)[variant];
